// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";

import lodash from "lodash";
// import Headful from "headful";
import * as VueGoogleMaps from 'vue2-google-maps'
//// If you encounter issues with UglifyJS and Nuxt.js, try the following instead:
// import * as VueGoogleMaps from '~/node_modules/vue2-google-maps/src/main'


import vueScrollto from 'vue-scrollto'

import HeaderBlock from "@/components/blocks/header/header.block.vue";
import LogoBlock from "@/components/blocks/logo-block/logo.block.vue";

/**
 * Vue configuration.
*/
Vue.config.productionTip = false;


Vue.component("logo-block", LogoBlock);
Vue.component("header-block", HeaderBlock);

Vue.set(Vue.prototype, "$lodash", lodash);

Vue.filter("stripHtml", function(data) {
	if (typeof data !== "string") return "";
	var doc = new DOMParser().parseFromString(data, "text/html");
	return doc.body.textContent || "";
});

// Global event bus.
export const bus = new Vue();
/**
 * Vue Initialization.
 */
/* eslint-disable no-new */
new Vue({
	el: "#app",
	router,
	template: "<App/>",
	components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js